import React from "react";
import { createPortal } from "react-dom";
import StudentEditModalHeader from "./StudentEditModalHeader";
import StudentEditPhotoUploadSection from "./StudentEditPhotoUploadSection";
import StudentEditFormFields from "./StudentEditFormFields";

export default function StudentEditModal({
  isOpen,
  demoAction,
  listType,
  editingStudent,
  modalPos,
  onMouseDown,
  onClose,
  icons,
  onSubmit,
  formData,
  isUploading,
  onImageUpload,
  setFormData,
  allDepartments,
  theme,
}) {
  if (!isOpen) return null;

  const isTouring = demoAction === "demo_add_student";
  const isTeacher = listType === "teacher";
  const title = isTeacher
    ? editingStudent
      ? "교사 정보 수정"
      : "새 교사 등록"
    : editingStudent
      ? "학생 정보 수정"
      : "새 학생 등록";

  return createPortal(
    <div
      className={`fixed inset-0 flex items-center justify-center z-[5000] p-4 ${
        isTouring ? "bg-black/10" : "bg-transparent"
      }`}
      style={{ zIndex: 5000 }}
    >
      <div
        id="tour-student-modal"
        className="bg-[#FFFFFF] backdrop-blur-xl rounded-[2.5rem] w-full max-w-2xl shadow-2xl relative border border-white/50 max-h-[90vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: `translate(${modalPos.x}px, ${modalPos.y}px)` }}
      >
        <StudentEditModalHeader
          iconSrc={icons.student}
          title={title}
          onMouseDown={onMouseDown}
          onClose={onClose}
        />

        <form
          onSubmit={onSubmit}
          className="flex-1 overflow-y-auto px-8 pb-8 custom-scrollbar space-y-6 pt-4 overscroll-contain"
        >
          <StudentEditPhotoUploadSection
            formData={formData}
            isUploading={isUploading}
            onImageUpload={onImageUpload}
          />

          <StudentEditFormFields
            formData={formData}
            setFormData={setFormData}
            allDepartments={allDepartments}
            theme={theme}
          />
          <button
            className={`w-full ${theme.bg} text-white py-4 rounded-2xl font-black text-lg hover:opacity-90 transition shadow-lg ${theme.shadow} mt-4`}
          >
            저장하기
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
}
